module.exports = __webpack_public_path__ + "static/media/flag.f9087ebe.svg";